export enum IssueSourceType {
    Other = 0,
    Equipment = 1,
    SiteEquipment = 2,
    Site = 3,
    VideoStream = 4,
    Functionality = 5,
}
